import { makeStyles } from 'tss-react/mui';
import { link } from '../../styles/jss/utils';
import { colors, spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme) => ({
    title: Object.assign(Object.assign(Object.assign({}, (theme.isFlyingFlowers ? theme.typography.medium_bold : theme.typography.xl_bold)), (theme.isFlyingFlowers ? theme.typographySpacing.medium_bold_lg : theme.typographySpacing.xl_bold_sm)), { [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, (theme.isFlyingFlowers ? theme.typography.large_bold : undefined)), (theme.isFlyingFlowers ? theme.typographySpacing.xl_bold_lg : theme.typographySpacing.xl_bold_sm)) }),
    message: {
        '& p': Object.assign(Object.assign(Object.assign(Object.assign({}, theme.typography.small_regular), { color: colors.grey.grey6 }), theme.typographySpacing.xl_regular_sm), { marginBottom: `${theme.typographySpacing.xl_regular_sm.marginBottom}!important` }),
        [theme.breakpoints.up('md')]: {
            '& p': Object.assign(Object.assign(Object.assign({}, theme.typography.medium_regular), theme.typographySpacing.small_regular_lg), { marginBottom: `${theme.typographySpacing.small_regular_lg.marginBottom}!important` }),
        },
    },
    termIndex: {
        marginRight: 4,
    },
    birthDayCampaignFormContainer: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
    },
    buttons: {
        display: 'flex',
        justifyContent: 'center',
    },
    saveButton: {
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '180px',
            height: '44px',
        },
    },
    input: Object.assign(Object.assign({}, theme.typographySpacing.xl_regular_sm), { [theme.breakpoints.up('md')]: {
            width: '384px',
        } }),
    privacyPolicyRow: {
        display: 'flex',
        alignItems: 'flex-start',
        marginBottom: spacing.medium,
    },
    privacyPolicyText: {
        display: 'flex',
        justifyContent: 'center',
        '& p': Object.assign(Object.assign({}, (theme.isFlyingFlowers ? theme.typography.xxs_regular : undefined)), { color: colors.grey.grey6, marginTop: 0, maxWidth: 804, marginBottom: `0px !important`, [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.small_regular), '& a, & button': Object.assign(Object.assign({}, link(theme.isFlyingFlowers ? undefined : colors.primary.gold4)), { color: theme.isFlyingFlowers ? colors.black[700] : colors.primary.gold5, display: 'inline' }) }),
    },
    inputRow: {
        display: 'flex',
        flexDirection: 'column',
        columnGap: spacing.medium,
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
        },
    },
    formContainer: {
        maxWidth: 795,
    },
    postSubmissionText: Object.assign(Object.assign({}, theme.typography.medium_bold), { marginTop: spacing.xl, textAlign: 'center', [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.xl_bold) }),
    postSubmissionTextChild: {
        marginTop: spacing.large,
    },
    numberedListTitle: Object.assign({}, theme.typography.small_regular),
    numberedList: Object.assign({}, theme.typography.small_regular),
    termsContainer: {
        marginTop: spacing.xl,
    },
    privacyPolicyLink: {
        color: theme.isFlyingFlowers ? colors.black[700] : colors.grey.grey6,
        textDecoration: 'underline',
    },
}));
export default useStyles;
